

export default function MenuItemsServicios(dispatch) {
    return [
        {
            label: "Nueva Orden de Servicio",
            icon: "pi pi-fw pi-plus",
            // command: abrirVentanaCrearFia,
        },
        {
            label: "Listar Ordenes de Servicios",
            icon: "pi pi-fw pi-list",
            // command: abrirVentanaQueryFias,
        },
        {
            separator: true,
        },
        {
            label: "Listar Servicios Comerciales de Internet",
            icon: "pi pi-fw pi-list",
            // command: abrirVentanaQueryFias,
        },
        {
            separator: true,
        },
        {
            label: "Reporte de Servicios",
            icon: "pi pi-fw pi-list",
            // command: abrirVentanaQueryFias,
        },
        {
            separator: true,
        },
         
        {
            label: "Lista de Eventos",
            icon: "pi pi-fw pi-list",
            // command: abrirVentanaQueryFias,
        },
        {
            separator: true,
        },
        {
            label: "Configuración",
            icon: "pi pi-fw pi-list",
            // command: abrirVentanaQueryFias,
        },
    ];
 

    
    
    
    
    
    //   return <Menubar model={items} />;
}

